import { Site } from '@envato/foundation-types'

interface INoIndexParams {
  name: string
  value?: string
}

interface INoIndexAllowList {
  site: Site
  routes: string[]
  params: INoIndexParams[]
}

type AllowedTagsBySite = {
  [site: string]: string[]
}

const allAllowedTagsBySite: AllowedTagsBySite = {
  [Site.audiojungle]: [
    'arabic',
    'black friday',
    'erotic',
    'happy new year',
    'quiz',
    'real estate',
    'subscription',
    'youtube',
    'advertising',
    'wedding invitation',
    'weather forecast',
    'happy birthday',
    'breaking news',
    'slot machine',
    'islamic',
    'torrent',
    'podcast',
    'marvel',
    'anime',
    'login',
    'crack',
    'video',
    'emoji',
    'sexy',
    'new year countdown',
    'kinetic typography',
    'mission impossible',
    'chinese new year',
    'wheel of fortune',
    'awards ceremony',
    'cinematic intro',
    'explainer video',
    'christmas intro',
    'game of thrones',
    'logo animation',
    'product launch',
    'text animation',
    'youtube intro',
    'splash screen',
    'storytelling',
    'harry potter',
    'thanksgiving',
    'freeze frame',
    'logo reveal',
    'stop motion',
    'lamborghini',
    'news opener',
    'news intro',
    'logo intro',
    'volleyball',
    'vlog intro',
    'battleship',
    'red carpet',
    'heartbeat',
    'countdown',
    'star wars',
    'cyberpunk',
    'synthwave',
    'flashback',
    'talk show',
    'superhero',
    'slideshow',
    'coca cola',
    'audiobook',
    'steampunk',
    'demo reel',
    'showreel',
    'egyptian',
    'hologram',
    'reindeer',
    'montage',
    'stinger',
    'ramadan',
    'samurai',
    'keynote',
    'scooter',
    'teaser',
    'hacker',
    'disney',
    'opener',
    'upload',
    'forest',
    'monkey',
    'pirate',
    'batman',
    'glitch',
    'soccer',
    'intro',
    'stomp',
    'outro',
    'promo',
    '8-bit',
    'ak47',
    'igtv',
    'hype',
    'rap',
    'sfx',
    '80s',
    '90s',
    'who wants to be a millionaire',
    'twinkle twinkle little star',
    'pirates of the caribbean',
    'funny background music',
    'technical difficulties',
    'kaun banega crorepati',
    'emotional background',
    'sad background music',
    'ladies and gentlemen',
    '12 days of christmas',
    'national geographic',
    'motivational speech',
    'winner announcement',
    'two steps from hell',
    'cartoon voice uh-oh',
    'epic trailer music',
    'people are awesome',
    'bow-chicka-wow-wow',
    'notification sound',
    'logo sound effects',
    'guinea+fowl+sounds',
    'spaghetti western',
    'santa claus voice',
    'world of warcraft',
    'winter wonderland',
    'background music',
    'opening ceremony',
    'we will rock you',
    'ludovico einaudi',
    'romeo and juliet',
    'mission complete',
    'man yelling stop',
    'post-apocalyptic',
    'cinematic impact',
    'chariots of fire',
    'game over sound',
    'motion graphics',
    'news background',
    'charlie chaplin',
    'christmas bells',
    'michael jackson',
    'native american',
    'stranger things',
    'imagine dragons',
    'gregorian chant',
    'national anthem',
    'harley davidson',
    'attack on titan',
    '8 bit game over',
    'christmas party',
    'flashback sound',
    'horror ambience',
    'desi dhol beat',
    'heart touching',
    'award ceremony',
    'space invaders',
    'record scratch',
    'correct answer',
    'audio branding',
    'single gunshot',
    'level complete',
    'child laughing',
    'horror trailer',
    'royal entrance',
    'spanish guitar',
    'japanese flute',
    'access granted',
    'deck the halls',
    'throat singing',
    'cinematography',
    'cinematic horn',
    'bungee jumping',
    'christmas jazz',
    'loading screen',
    'news headlines',
    'cinematic boom',
    'clint eastwood',
    'roulette wheel',
    'baby laughing',
    'tom and jerry',
    'robot walking',
    'marching band',
    'radio sweeper',
    'nursery rhyme',
    'podcast intro',
    'wedding music',
    'defibrillator',
    'bottle opener',
    'snake charmer',
    'electro swing',
    'mortal kombat',
    'access denied',
    'cartoon music',
    'backing track',
    'enemies ahead',
    'woman panting',
    'jurassic park',
    'studio ghibli',
    'ticking clock',
    'weather intro',
    'clock ticking',
    'space shooter',
    'wedding march',
    'woman moaning',
    'casey neistat',
    'frank sinatra',
    'tower defense',
    'debbie downer',
    'miss universe',
    'jingle bells',
    'girl moaning',
    'fast forward',
    'bodybuilding',
    'indian flute',
    'fashion show',
    'minion laugh',
    'bumper music',
    'bass boosted',
    'arabic music',
    'korean drama',
    'infographics',
    'comedy drama',
    'clapperboard',
    'sniper rifle',
    'female voice',
    'ready set go',
    'instrumental',
    'mickey mouse',
    'time passing',
    'audio jingle',
    'dark ambient',
    'call of duty',
    'wolf whistle',
    'product demo',
    'reality show',
    'horror intro',
    'horror music',
    'audiomachine',
    'bamboo flute',
    'singing bowl',
    'allahu akbar',
    'chinese drum',
    'female vocal',
    'music bundle',
    'wrong answer',
    'korean music',
    'pink panther',
    'upbeat drums',
    'wedding song',
    'police siren',
    'stomp opener',
    'ghostbusters',
    'scandinavian',
    'sleigh bells',
    'tribal drums',
    'travel video',
    'bank robbery',
    'blade runner',
    'martial arts',
    'monster roar',
    'man moaning',
    'alan walker',
    'jungle beat',
    'slow motion',
    'eid mubarak',
    'prize wheel',
    'hans zimmer',
    'documentary',
    'news jingle',
    'sword fight',
    'logo jingle',
    'belly dance',
    'intro music',
    'laugh track',
    'sleigh ride',
    'silent hill',
    'finger snap',
    'lower third',
    'puppet show',
    'short intro',
    'future bass',
    'touchscreen',
    'let it snow',
    'radio intro',
    'tron legacy',
    'fruit ninja',
    'fight scene',
    'barry white',
    'funny piano',
    'puzzle game',
    'candy crush',
    'cock crying',
    'sexy voice',
    'audio mark',
    '10 seconds',
    'short film',
    'jump scare',
    'sexy sound',
    '30 seconds',
    'logo sound',
    '15 seconds',
    'aftermovie',
    'water drop',
    'hyperlapse',
    'aboriginal',
    'mardi gras',
    'breakdance',
    'soundtrack',
    'terminator',
    'sony vegas',
    'transition',
    'logo sting',
    'award show',
    'didgeridoo',
    'game music',
    'epic music',
    'evil laugh',
    'deep house',
    'james bond',
    'tinkerbell',
    'a.r.rahman',
    'audio logo',
    'sad violin',
    'taiko drum',
    'commentary',
    'cinderella',
    'benny hill',
    'sam kolder',
    'epic intro',
    'ode to joy',
    'nutcracker',
    'hallelujah',
    'love music',
    '60 seconds',
    'pink floyd',
    'snoop dogg',
    'lion dance',
    'telenovela',
    'epic choir',
    'lion roar',
    'thug life',
    'bass drop',
    'male moan',
    'game show',
    'watermark',
    'voiceover',
    'bollywood',
    'afro beat',
    'ringtones',
    'pennywise',
    'reggaeton',
    'war drums',
    'drum beat',
    'peppa pig',
    'retrowave',
    'stopwatch',
    'sad piano',
    'drum roll',
    'indonesia',
    'paparazzi',
    'timelapse',
    'xenomorph',
    'bruce lee',
    '80s synth',
    'mongolian',
    'tick tock',
    'app promo',
    'king kong',
    'rick ross',
    'pan flute',
    'backsound',
    'drum solo',
    'film noir',
    'hard bass',
    'xylophone',
    'sandstorm',
    'gibberish',
    'hang drum',
    'daft punk',
    'time warp',
    'announcer',
    'ave maria',
    'harmonium',
    'bossanova',
    'detective',
    'vlogging',
    'ho ho ho',
    'ghungroo',
    '1 minute',
    'attitude',
    'acapella',
    'jeopardy',
    'afrobeat',
    'showtime',
    'mariachi',
    'big boss',
    'build up',
    'japanese',
    'gujarati',
    'moroccan',
    'rap beat',
    'identify',
    'eurobeat',
    'thriller',
    'unboxing',
    'hawaiian',
    'vibrator',
    'avengers',
    'drumline',
    'bagpipes',
    'bloopers',
    'dialogue',
    'sad song',
    'pakhawaj',
    'carillon',
    'chiptune',
    'la la la',
    'pakistan',
    'ramadhan',
    'tik tok',
    'jingles',
    'punjabi',
    'beatbox',
    'bansuri',
    'villain',
    'jumanji',
    'kung fu',
    'italian',
    'bengali',
    'turkish',
    'nigeria',
    'moaning',
    'mexican',
    'gamelan',
    'contact',
    'bhangra',
    'aladdin',
    'burnout',
    'doo wop',
    'pickaxe',
    'shaolin',
    'pokemon',
    'whisper',
    'tibetan',
    'powtoon',
    'fanfare',
    'match 3',
    'bla bla',
    'whistle',
    'timeout',
    'orgasm',
    'b roll',
    'dholak',
    'remove',
    'stings',
    'kawaii',
    'viking',
    'minion',
    '16-bit',
    'diwali',
    '20 sec',
    'balkan',
    'mantra',
    'woohoo',
    '432 hz',
    '15 sec',
    'pacman',
    'sitcom',
    'cumbia',
    'shaman',
    'tetris',
    'climax',
    'odesza',
    'jewish',
    'colors',
    'gagged',
    'comedy',
    'nagada',
    'oh no',
    'horny',
    'lo-fi',
    'prank',
    '1950s',
    'joker',
    'nepal',
    'pingu',
    'opera',
    'ninja',
    'troll',
    'swipe',
    'hindi',
    'toing',
    'genie',
    'stems',
    'greek',
    'shine',
    'drums',
    'tizer',
    'pixel',
    'dhol',
    'jump',
    'junk',
    'tada',
    'mg42',
    'auto',
    'thai',
    'clap',
    'epic',
    'kpop',
    'trap',
    'asmr',
    'bali',
    'midi',
    'bgm',
    'wwe',
    'nba',
    'akm',
    'sex',
    'oud',
    'yum',
    'ivr',
    'yay',
    'eww',
    'edm',
    'om',
    '8k'
  ],

  [Site.codecanyon]: [
    'advertising',
    'black friday',
    'quiz',
    'real estate',
    'sell',
    'youtube',
    'advertising',
    'arabic',
    'black friday',
    'erotic',
    'happy new year',
    'happy new year',
    'quiz',
    'real estate',
    'sell',
    'social media',
    'subscription',
    'youtube',
    'merry christmas',
    'happy birthday',
    'travel agency',
    'breaking news',
    'slot machine',
    'statistics',
    'mobile app',
    'e-learning',
    'newspaper',
    'instagram',
    'astrology',
    'christmas',
    'valentine',
    'pharmacy',
    'business',
    'calendar',
    'new year',
    'podcast',
    'mockup',
    'lyrics',
    'login',
    'video',
    'crack',
    'team',
    'learning management system',
    'artificial intelligence',
    'business directory',
    'doctor appointment',
    'wheel of fortune',
    'price comparison',
    'event management',
    'booking calendar',
    'customer support',
    'amazon affiliate',
    'personal trainer',
    'material design',
    'cryptocurrency',
    'animated icons',
    'admin template',
    'christmas card',
    'restaurant app',
    'social network',
    'knowledge base',
    'event calendar',
    'online booking',
    'classified ads',
    'hotel booking',
    'radio station',
    'video gallery',
    'splash screen',
    'pricing table',
    'greeting card',
    'laravel admin',
    'react native',
    'stock market',
    'crowdfunding',
    'user profile',
    'landing page',
    'model agency',
    'tour package',
    'marketplace',
    'android app',
    'admin panel',
    'google maps',
    'photography',
    'santa claus',
    'woocommerce',
    'auto repair',
    'job portal',
    'freelancer',
    'tournament',
    'investment',
    'blockchain',
    'accounting',
    'classified',
    'temple run',
    'ecommerce',
    'job board',
    'live chat',
    'elearning',
    'mega menu',
    'animation',
    'elementor',
    'music app',
    'dashboard',
    'messenger',
    'community',
    'audiobook',
    'angularjs',
    'magazine',
    'flipbook',
    'helpdesk',
    'intranet',
    'snapchat',
    'facebook',
    'brochure',
    'hospital',
    'fitness',
    'laravel',
    'grocery',
    'booking',
    'twitter',
    'medical',
    'shopify',
    'courier',
    'invoice',
    'trading',
    'groupon',
    'spotify',
    'blogger',
    'laundry',
    'coupon',
    'crypto',
    'wallet',
    'nodejs',
    'casino',
    'airbnb',
    'lawyer',
    'modern',
    'twitch',
    'dating',
    'banner',
    'fiverr',
    'survey',
    'forum',
    'ionic',
    'ebook',
    'udemy',
    'dokan',
    'whmcs',
    'react',
    'vcard',
    'kiosk',
    'hyip',
    'game',
    'chat',
    'html',
    'saas',
    'wiki',
    'iptv',
    'hack',
    'imdb',
    'snow',
    'crm',
    'php',
    'pos',
    'pwa',
    'mlm',
    'lms',
    'erp',
    'faq',
    'seo',
    'cms',
    'gif',
    'best school management system',
    'medical store software php. open source pharmacy software',
    'woocommerce embed videos to product image gallery',
    'movie ticket booking android app source code',
    'online movie ticket booking project in php',
    'open source hospital management system',
    'codeigniter school management system',
    'open source php online exam system',
    'youtube video downloader script',
    'contact form 7 payment gateway',
    'bus booking system open source',
    'woocommerce product calculator',
    'dream11 clone cricket script',
    'bus seat booking code in php',
    'booking app full source code',
    'custom tailored suits online',
    'javascript t-shirt designer',
    'business card design plugin',
    'custom t shirt design maker',
    'video subscription platform',
    'whatsapp status downloader',
    'hospital management system',
    'pharmacy management system',
    'employee management system',
    'pdf viewer for php website',
    'housing society management',
    'whatsapp status video odia',
    'woocommerce sold out badge',
    'facebook video downloader',
    'exam admit card generator',
    'library management system',
    'jquery organization chart',
    'two-factor authentication',
    'college management system',
    'woocommerce food delivery',
    'student management system',
    'website traffic generator',
    'school management system',
    'mobile phone case design',
    'form builder open source',
    'tiktok video downloader',
    'codeigniter admin panel',
    'bookmyshow clone script',
    'woocommerce flash sale',
    'buildbox game template',
    'bus reservation system',
    'loan management system',
    'fake traffic generator',
    'lead management system',
    'thisiswhyimbroke clone',
    'email template builder',
    'convert website to app',
    'bkash payment gateway',
    'ubereats clone script',
    'product customization',
    'social network script',
    'online blood donation',
    'product configurator',
    'url shortener script',
    'inventory management',
    'instagram downloader',
    'woocommerce checkout',
    'woocommerce rest api',
    'breaking news ticker',
    'woocommerce supplier',
    'google web designer',
    'affiliate marketing',
    'accounting software',
    'online photo editor',
    'shipping calculator',
    'pubg tournament app',
    'animated background',
    'property management',
    'employee management',
    'organic traffic bot',
    'instagram analytics',
    'android source code',
    'youtube subscribers',
    'woocommerce coupons',
    'woocommerce gallery',
    'online news portal',
    'youtube downloader',
    'currency converter',
    'real estate script',
    'recent sales popup',
    'frontend dashboard',
    'website monitoring',
    'food delivery app',
    'invoice generator',
    'client management',
    'custom phone case',
    't-shirt ecommerce',
    'buildbox template',
    'ecommerce website',
    'remove background',
    'bulk email sender',
    'personality tests',
    'task rabbit clone',
    'laravel ecommerce',
    'office management',
    'homeadvisor clone',
    't-shirt designer',
    'video downloader',
    'product designer',
    'store management',
    'soundcloud clone',
    '360 virtual tour',
    'otp login signup',
    'eventbrite clone',
    'woocommerce cart',
    'order management',
    'practo clone app',
    'doctor directory',
    'cash on delivery',
    'tshirt ecommerce',
    'apartment rental',
    'hotel management',
    'php video script',
    'photo editor sdk',
    'candy crush saga',
    'email marketing',
    'product builder',
    'instagram clone',
    'website builder',
    'urbanclap clone',
    'android webview',
    'barcode scanner',
    'category filter',
    'video streaming',
    'bigbasket clone',
    'amazon dropship',
    'woocommerce app',
    'qr code scanner',
    'whatsapp status',
    'donation script',
    'horizontal menu',
    'foodpanda clone',
    'task management',
    'cost calculator',
    'interactive map',
    'jumia wordpress',
    'multiple choice',
    'mobile recharge',
    'movie streaming',
    'expense manager',
    'particle effect',
    'lead management',
    'airport shuttle',
    'responsive menu',
    'blablacar clone',
    'quote generator',
    'cricket betting',
    'payment gateway',
    'codeigniter pos',
    'whatsapp clone',
    'facebook clone',
    'restaurant pos',
    'bitcoin wallet',
    'wordpress game',
    'pricing slider',
    'content locker',
    'booking system',
    'onlyfans clone',
    'wp newz nulled',
    'order tracking',
    'product filter',
    'server monitor',
    'text to speech',
    'meme generator',
    'live streaming',
    'telegram clone',
    'resume builder',
    'buzzfeed clone',
    'virtual mirror',
    'contact form 7',
    'instagram feed',
    'android studio',
    'product slider',
    'youtube clone',
    'online course',
    'whatsapp form',
    'dating script',
    'photo sharing',
    'wallpaper app',
    'gravity forms',
    'spotify clone',
    'event booking',
    'animated menu',
    'url shortener',
    'ecommerce app',
    'purchase code',
    'coloring book',
    'business card',
    'food ordering',
    'email builder',
    'whatsapp chat',
    'vertical tabs',
    'sticky footer',
    'messenger bot',
    'bank transfer',
    'facebook quiz',
    'education app',
    'grofers clone',
    'shopping list',
    'patreon clone',
    'client portal',
    'opening hours',
    'file sharing',
    'swiggy clone',
    'seat booking',
    'avia builder',
    'react-native',
    'sidebar menu',
    'zomato clone',
    'dropshipping',
    'apk download',
    'testimonials',
    'video editor',
    'browser game',
    'photo editor',
    'forex signal',
    'fiverr clone',
    'scratch card',
    'redbus clone',
    'android game',
    'image upload',
    'task manager',
    'tiktok clone',
    'google drive',
    'file manager',
    'manga reader',
    'form builder',
    'hyip monitor',
    'video upload',
    'music charts',
    'flyer design',
    'google clone',
    'image editor',
    'prescription',
    'taxi booking',
    'movie script',
    'mlm software',
    'virtual tour',
    'codeigniter',
    'live stream',
    'online exam',
    'canva clone',
    'leaderboard',
    'construct 3',
    'online game',
    '8 ball pool',
    'online shop',
    'mobile game',
    'alidropship',
    'paytm clone',
    'geolocation',
    'quora clone',
    'grocery app',
    'source code',
    'post filter',
    'vin decoder',
    'file upload',
    'listing app',
    'pubg mobile',
    'time killer',
    'jquery chat',
    'news script',
    'app builder',
    'racing game',
    'particle js',
    'memory game',
    'laravel crm',
    'construct 2',
    'card slider',
    'online quiz',
    'rewards app',
    'slither.io',
    'dating app',
    'speed test',
    'floor plan',
    'video call',
    'newsletter',
    'dialogflow',
    'dictionary',
    'html5 game',
    'logo maker',
    'calculator',
    'gold price',
    'pos system',
    'school erp',
    'church app',
    'quote form',
    'eventbrite',
    'stick hero',
    '9gag clone',
    'helix jump',
    'aliexpress',
    'pdf viewer',
    'yelp clone',
    'buddypress',
    'android tv',
    'contact us',
    'uber clone',
    'phpmyadmin',
    'olx clone',
    'ola clone',
    'smm panel',
    'card game',
    'ludo game',
    '123movies',
    'downloads',
    'video cms',
    'flip book',
    'floorplan',
    'todo list',
    'movie cms',
    'free fire',
    'timesheet',
    'online tv',
    'affiliate',
    'wallpaper',
    'radio app',
    '3d slider',
    'timetable',
    'gift card',
    'pinterest',
    'antivirus',
    'crossword',
    'icon pack',
    'e-wallet',
    'php chat',
    'whatsapp',
    'telegram',
    'chat bot',
    'wowonder',
    'quiz app',
    'referral',
    'news app',
    'snaptube',
    'taxi app',
    'onlyfans',
    'linktree',
    'autoblog',
    'bulk sms',
    'fortnite',
    'dogecoin',
    'flaticon',
    'gambling',
    'chatroom',
    'seo tool',
    'chat app',
    'justdial',
    'reseller',
    'ethereum',
    'linkedin',
    'recharge',
    'backlink',
    'php crud',
    'openload',
    'razorpay',
    'three js',
    'rest api',
    'shoutbox',
    'ibilling',
    'phpmaker',
    'onsen ui',
    'suitecrm',
    'mailwizz',
    'buildbox',
    'cricbuzz',
    'roulette',
    'xamarin',
    'lottery',
    'webview',
    'betting',
    'marquee',
    'jackpot',
    'slither',
    'charity',
    'live tv',
    'alibaba',
    'vidmate',
    'bitcoin',
    'asp.net',
    'drawing',
    'flutter',
    'dream11',
    'lending',
    'ionic 3',
    'php pos',
    'cordova',
    'scraper',
    'countup',
    'contest',
    'svg map',
    'qr code',
    'reviews',
    'tiktok',
    'reskin',
    'raffle',
    'voting',
    'tinder',
    'kotlin',
    'epaper',
    'indeed',
    'adf.ly',
    'onetap',
    'python',
    'sngine',
    'cursor',
    'hybrid',
    'paypal',
    'canvas',
    'swiggy',
    'lottie',
    'schoex',
    'bit.ly',
    'mapbox',
    'uptime',
    'webcam',
    'fembed',
    'quotes',
    'kanban',
    'redeem',
    'ffmpeg',
    'health',
    'paxful',
    'unity',
    'wheel',
    'tarot',
    'forex',
    'poker',
    'frame',
    'trade',
    'bingo',
    'excel',
    'quran',
    'tools',
    'ecard',
    'badoo',
    'table',
    'gform',
    'viber',
    'admob',
    'popup',
    'chess',
    'gojek',
    'venmo',
    'swift',
    'ip tv',
    'uber',
    'ebay',
    'oxoo',
    'gsap',
    'tmdb',
    'menu',
    'java',
    'hrms',
    'vpn',
    'ptc',
    'olx',
    'mp3',
    'ocr',
    'mcq',
    'sap',
    'otp'
  ],

  [Site.photodune]: [
    'erotic',
    'social media',
    'subscription',
    'business',
    'calendar',
    'sexy',
    'torrent',
    'adalt',
    'application',
    'ayurveda',
    'ayurveda',
    'black',
    'chinese new year',
    'elements',
    'lesbian',
    'logo',
    'pantyhose',
    'pasta',
    'payment',
    'support',
    'upload',
    'action',
    'agronomist',
    'aikido',
    'amsterdam canal houses',
    'animals',
    'apocalypse',
    'apocalyptic',
    'applying',
    'arms wide spread',
    'asian ethnicity',
    'ayurvedic',
    'background',
    'backlighting',
    'bahrain',
    'bakalaw',
    'ballet',
    'bangladeshi',
    'bed',
    'best',
    'billed',
    'bird of pray',
    'biro yorkshire terrier',
    'bite',
    'blueberry',
    'blur',
    'bondage',
    'booty',
    'bottomless',
    'box',
    'burnt',
    'business meeting',
    'butt',
    'buttocks',
    'bveak',
    'candid',
    'candy cane',
    'cane corso',
    'carronts',
    'casual clothing',
    'cavalier king charles spaniel',
    'centaurea cyanus',
    'chabo',
    'cheesy',
    'chicory',
    'chili peppers',
    'chubby',
    'cosmetic surgery',
    'farm worker',
    'fashion model',
    'frontal',
    'girls in bed',
    'granny',
    'habrchad',
    'inga',
    'jokulsarlon lagoon',
    'lingerie',
    'mature women',
    'numida meleagris',
    'panties',
    'pata rat',
    'people',
    'physical therapy',
    'plasma ball',
    'selling',
    'shell',
    'site',
    'sparkler',
    'submit',
    'sunscreen',
    'template',
    'theme',
    'tiger cub',
    'topless',
    'toychik',
    'udelo',
    'undressed'
  ],

  [Site.threedocean]: [
    'arabic',
    'erotic',
    'sell',
    'social media',
    'merry christmas',
    'cosmetics',
    'instagram',
    'pharmacy',
    'football',
    'cricket',
    'islamic',
    'jewelry',
    'mockup',
    'marvel',
    'emoji',
    'anime',
    'sexy',
    'cake',
    'taxi',
    'lamborghini',
    'volleyball',
    'battleship',
    'temple run',
    'world map',
    'coca cola',
    'ice cream',
    'isometric',
    'superhero',
    'steampunk',
    'reindeer',
    'confetti',
    'envelope',
    'graffiti',
    'iron man',
    'egyptian',
    'ramadan',
    't-shirt',
    'samurai',
    'scooter',
    'mosque',
    'horror',
    'ribbon',
    'bakery',
    'casino',
    'poster',
    'nature',
    'mosaic',
    'monkey',
    'dragon',
    'batman',
    'busty',
    'vinyl',
    'kiosk',
    'smoke',
    'pasta',
    'ak47',
    'lion',
    'pubg',
    'gfx',
    'sax',
    'gay',
    '4k',
    'samsung galaxy s10 after effects model',
    'monster energy 3d model obj',
    'rigged low poly soldier',
    'mercedes-benz sprinter',
    'volkswagen transporter',
    'element 3d basketball',
    '4k seamless textures',
    'maserati granturismo',
    'mitsubishi outlander',
    'toyota land cruiser',
    'louisiana superdome',
    'shipping container',
    'volkswagen crafter',
    'konark sun temple',
    'supplement bottle',
    'low poly building',
    'offshore platform',
    'volkswagen passat',
    'interior 3d scene',
    'exhibition stall',
    'post apocalyptic',
    'exhibition stand',
    'energy drink obj',
    'ashley furniture',
    'aquiles adrianza',
    'inspector gadget',
    'maserati levante',
    'post-apocalypse',
    'toyota vellfire',
    'sanitary napkin',
    'freightliner m2',
    'baseball jersey',
    'mitsubishi fuso',
    'corona renderer',
    'dropper bottle',
    'monster energy',
    'ice cream cone',
    'toyota coaster',
    'toyota corolla',
    'clash of clans',
    'drinking straw',
    'octane render',
    'concert stage',
    'bougainvillea',
    'lowpoly earth',
    'tahrir square',
    'shopping mall',
    'train station',
    'plastic chair',
    'jeep wrangler',
    'multitexture',
    'low poly car',
    'hdri cartoon',
    'fluid splash',
    'toyota hiace',
    'bmw 1 series',
    'boca do lobo',
    'perodua myvi',
    'bmw 4 series',
    'condensation',
    'suzuki jimny',
    'french fries',
    'karim rashid',
    'queens blade',
    'stage design',
    'toyota hilux',
    'planet earth',
    'adolf hitler',
    'opel calibra',
    'toyota yaris',
    'neoclassical',
    '3d panic bar',
    'balloon gate',
    'renault clio',
    'clash royale',
    'desert eagle',
    'cricket ball',
    'toyota mirai',
    'lotus esprit',
    'refrigerator',
    'foam rubber',
    'mini cooper',
    'beer bottle',
    'coffee bean',
    'rolls royce',
    'gingerbread',
    'wine bottle',
    'porsche 911',
    'airpod case',
    'qutub minar',
    'range rover',
    'car mr bean',
    'environment',
    'bodybuilder',
    'isuzu d-max',
    'f-22 raptor',
    'hot tub spa',
    'pirate ship',
    'tie fighter',
    'transformer',
    'hairdresser',
    'underwater',
    'trade show',
    'watermelon',
    'hoverboard',
    'human skin',
    'empty room',
    'microphone',
    'perforated',
    'high heels',
    'strawberry',
    'anglerfish',
    'necromancy',
    'playground',
    'tumbleweed',
    'element 3d',
    'koenigsegg',
    'opel astra',
    'paw-patrol',
    'racing car',
    'star field',
    'cement bag',
    'continents',
    'streetwear',
    'packaging',
    'mannequin',
    'cigarette',
    'hairstyle',
    'racetrack',
    'hamburger',
    'billboard',
    'crocodile',
    'destroyed',
    'limestone',
    'underwear',
    'world cup',
    'airstream',
    'parachute',
    'starbucks',
    'pineapple',
    'chocolate',
    'minecraft',
    'backplate',
    'snowflake',
    'terrorist',
    'sheepskin',
    'astronaut',
    'tombstone',
    'satellite',
    'trash can',
    'astroturf',
    'beanstalk',
    'mcdonalds',
    'palm tree',
    'dandelion',
    'fido dido',
    'spaghetti',
    'dystopian',
    'ssangyong',
    'base mesh',
    'mistletoe',
    'peterbilt',
    'fiat tipo',
    'photobook',
    'signboard',
    'spaceship',
    'sunflower',
    'alphabet',
    'lightbox',
    'refinery',
    'iphone x',
    'mustache',
    'negligee',
    'fountain',
    'cauldron',
    'blazblue',
    'tentacle',
    'bacteria',
    'floating',
    'firewood',
    'realflow',
    'sidewalk',
    'tiramisu',
    'cadillac',
    'plumeria',
    'backpack',
    'mushroom',
    'superman',
    'swimsuit',
    'anaconda',
    'baguette',
    'cassette',
    'haystack',
    'narbutas',
    'poliform',
    'sketchup',
    'sombrero',
    'trophies',
    'bookcase',
    'caustics',
    'corduroy',
    'iphone 6',
    'maserati',
    'popcorn',
    'feather',
    'coconut',
    'softbox',
    'skydome',
    'bambina',
    'balloon',
    'dropper',
    'whiskey',
    'volcano',
    'haircut',
    'cupcake',
    'lettuce',
    'boombox',
    'crystal',
    'cubemap',
    'bananas',
    'iceberg',
    'antenna',
    'bmw e30',
    'chicken',
    'stomach',
    'fireman',
    'gorilla',
    'ketupat',
    'protein',
    'lantern',
    'pergola',
    'audi r8',
    'flowers',
    'g-class',
    'helipad',
    'cracked',
    'dxracer',
    'gazelle',
    'missile',
    'seaweed',
    'model x',
    'airpods',
    'jupiter',
    'shelter',
    'bugatti',
    'emerald',
    'giraffe',
    'pitbull',
    'roll-up',
    'plywood',
    'cendres',
    'mock-up',
    'parasol',
    'hamster',
    'bandaid',
    'bazooka',
    'blister',
    'ladybug',
    'minotti',
    'muscles',
    'concert',
    'kremlin',
    'pac-man',
    'pumpkin',
    'ripstop',
    'rooster',
    'syringe',
    'vampire',
    'hentai',
    'pierce',
    'cosmos',
    'bamboo',
    'rigged',
    'cracks',
    'sclera',
    'adidas',
    'scania',
    'stucco',
    'ducato',
    'circus',
    'smiley',
    'vondom',
    'cheese',
    'e-tron',
    'podium',
    'saturn',
    'burger',
    'corpse',
    'diaper',
    'cotton',
    'prison',
    'suzuki',
    'cactus',
    'walnut',
    'shader',
    'breast',
    'almond',
    'skybox',
    'zombie',
    'bleach',
    'sachet',
    'mpt-76',
    'guitar',
    'noodle',
    'bmw i3',
    'bikini',
    'coffin',
    'nebula',
    'yellow',
    'dollar',
    'subaru',
    'tomato',
    'trophy',
    'cowboy',
    'facade',
    'grader',
    'harbor',
    't pose',
    'hockey',
    'cherry',
    'ertiga',
    'fanoos',
    'kitten',
    'tamiya',
    'yamaha',
    'zafira',
    'kuwait',
    'allium',
    'baxter',
    'awning',
    'bazaar',
    'crisps',
    'golden',
    'lizard',
    'luster',
    'naruto',
    'piston',
    'tavern',
    'young',
    'beard',
    'pills',
    'petal',
    'chips',
    'hijab',
    'skate',
    'chibi',
    'straw',
    'saree',
    'lib4d',
    'furry',
    'iveco',
    'steak',
    'bread',
    'clo3d',
    'veins',
    'donut',
    'ecchi',
    'lemon',
    'pears',
    'pepsi',
    'brain',
    'jesus',
    'hiace',
    'beret',
    'float',
    'easel',
    'flags',
    'mulch',
    'truss',
    'fruit',
    'mecha',
    'noose',
    'whale',
    'plant',
    'egypt',
    'grass',
    'birch',
    'glock',
    'spear',
    'turri',
    'bmw 2',
    'earth',
    'geode',
    'globe',
    'onion',
    'peach',
    'prado',
    'jeans',
    'kebab',
    'plush',
    'shark',
    'tiger',
    'vespa',
    'wheat',
    'lemur',
    'boots',
    'cloak',
    'icing',
    'jelly',
    'slums',
    'snack',
    'knot',
    'meat',
    'fort',
    'vray',
    'lips',
    'rope',
    'tent',
    'foam',
    'clay',
    'claw',
    'buoy',
    'pack',
    'coal',
    'goat',
    'tire',
    'jade',
    'wool',
    'f-16',
    'horn',
    'sack',
    'gums',
    'scat',
    'feet',
    'fifa',
    'hulk',
    'imvu',
    'lego',
    'milk',
    'fj40',
    'bebo',
    'bags',
    'duck',
    'iris',
    'beer',
    'kitt',
    'rust',
    'zoid',
    'kufi',
    'arab',
    'hdri',
    'kart',
    'mask',
    'oreo',
    'sand',
    'wig',
    'rts',
    'rug',
    'bb8',
    'e46',
    'ham',
    'fat',
    'kfc',
    'boy',
    'cow',
    'ivy',
    'bmw',
    'cat',
    'ufo',
    'hdr',
    'aid',
    'cbr',
    'f35',
    'npc'
  ],

  [Site.videohive]: [
    'advertising',
    'arabic',
    'black friday',
    'erotic',
    'happy new year',
    'quiz',
    'real estate',
    'sell',
    'social media',
    'subscription',
    'youtube',
    'wedding invitation',
    'weather forecast',
    'merry christmas',
    'happy birthday',
    'breaking news',
    'travel agency',
    'slot machine',
    'mobile app',
    'statistics',
    'e-learning',
    'christmas',
    'newspaper',
    'valentine',
    'cosmetics',
    'astrology',
    'new year',
    'calendar',
    'football',
    'islamic',
    'torrent',
    'cricket',
    'jewelry',
    'mockup',
    'lyrics',
    'marvel',
    'emoji',
    'crack',
    'login',
    'anime',
    'cake',
    'taxi',
    'team',
    'artificial intelligence',
    'new year countdown',
    'kinetic typography',
    'mission impossible',
    'company profile',
    'awards ceremony',
    'game of thrones',
    'explainer video',
    'christmas intro',
    'cinematic intro',
    'interior design',
    'logo animation',
    'christmas card',
    'text animation',
    'product launch',
    'animated icons',
    'graphic design',
    'youtube intro',
    'greeting card',
    'photo gallery',
    'freeze frame',
    'harry potter',
    'architecture',
    'thanksgiving',
    'beauty salon',
    'presentation',
    'logo reveal',
    'santa claus',
    'coming soon',
    'news opener',
    'stop motion',
    'coffee shop',
    'news intro',
    'logo intro',
    'e-commerce',
    'vlog intro',
    'red carpet',
    'web design',
    'slideshow',
    'education',
    'world map',
    'cyberpunk',
    'demo reel',
    'heartbeat',
    'talk show',
    'synthwave',
    'logistics',
    'flashback',
    'isometric',
    'pantyhose',
    'star wars',
    'furniture',
    'showreel',
    'hologram',
    'parallax',
    'snapchat',
    'confetti',
    'facebook',
    'envelope',
    'brochure',
    'graffiti',
    'iron man',
    'lesbian',
    'stinger',
    'dentist',
    'montage',
    'finance',
    'keynote',
    'disney',
    'coffee',
    'poster',
    'teaser',
    'twitch',
    'horror',
    'travel',
    'banner',
    'mosaic',
    'dragon',
    'beauty',
    'glitch',
    'forest',
    'pirate',
    'opener',
    'ribbon',
    'intro',
    'busty',
    'outro',
    'vinyl',
    'music',
    '8-bit',
    'adalt',
    'promo',
    'pizza',
    'stomp',
    'smoke',
    'retro',
    'hype',
    'lion',
    'vlog',
    'hack',
    'pubg',
    'igtv',
    'snow',
    'sax',
    'sfx',
    'gym',
    '80s',
    'gay',
    'gfx',
    'gif',
    '90s',
    'rap',
    'cv',
    'dj',
    'ui',
    '4k',
    'handy seamless transitions',
    'corporate presentation',
    'after effects plugins',
    'tv studio background',
    'christmas transition',
    'happy christmas gift',
    'animated lower third',
    'christmas greetings',
    'music visualization',
    'character animation',
    'audio visualization',
    'christmas animation',
    'projection mapping',
    'wedding background',
    'digital background',
    'calendar animation',
    'back to the future',
    'instagram stories',
    'animated elements',
    'explainer toolkit',
    'animation studio',
    'music visualizer',
    'champions league',
    'romantic massage',
    't-shirt mock up',
    'snow transition',
    'title animation',
    'photo animation',
    'logo transition',
    'virtual reality',
    'digital signage',
    'beautiful girl',
    'audio spectrum',
    'football intro',
    'first birthday',
    'christmas loop',
    '3d virtual set',
    'motion factory',
    'ink transition',
    'virtual studio',
    'adobe premiere',
    'photo template',
    'christmas tree',
    'save the date',
    'wedding intro',
    'bokeh overlay',
    'iphone mockup',
    'app promotion',
    'alpha channel',
    'wedding title',
    'website intro',
    'psd templates',
    'movie trailer',
    'animation kit',
    'playing cards',
    'photo collage',
    'premiere pro',
    '3d animation',
    '2d animation',
    'wedding pack',
    'kaleidoscope',
    'hud elements',
    'sports intro',
    'text effects',
    'broken glass',
    'progress bar',
    'travel intro',
    'superheroine',
    'glitch intro',
    'transformers',
    'text presets',
    'multi screen',
    'cooking show',
    'water splash',
    'deformation',
    'streaptease',
    'event promo',
    'reflections',
    'handwriting',
    'logo opener',
    'fire effect',
    'photo album',
    'anniversary',
    'sport promo',
    'mini bikini',
    'time travel',
    'speedometer',
    'supermarket',
    'defoliation',
    'baby shower',
    'homosexual',
    'sexy promo',
    'motion bro',
    'sexy woman',
    'film intro',
    'powerpoint',
    'led screen',
    'motorcycle',
    'app mockup',
    'comic book',
    'nomination',
    'walk cycle',
    'futuristic',
    'engagement',
    'capbarista',
    'game intro',
    'typewriter',
    'watercolor',
    'hand drawn',
    'lovers day',
    'love story',
    'mouse sesi',
    'torn paper',
    'night club',
    'chalkboard',
    'honeymoon',
    'subscribe',
    'explainer',
    'seductive',
    'interview',
    'page turn',
    'butterfly',
    'fireworks',
    'iphone 11',
    'thank you',
    'equalizer',
    'vaporwave',
    'fast food',
    'gold logo',
    'videowall',
    'wrestling',
    'waterfall',
    'foreplay',
    'carnival',
    'swipe up',
    'gift box',
    'backside',
    'timeline',
    'vj loops',
    'tempting',
    'hardcord',
    'military',
    'teenager',
    'election',
    'stripper',
    'vertical',
    'airplane',
    'polaroid',
    'waveform',
    'pinnacle',
    'scribble',
    'splatter',
    'resolume',
    'javanese',
    'farewell',
    'flash fx',
    'same-sex',
    'tv intro',
    'computer',
    'stickman',
    'hot hub',
    'brazier',
    'collage',
    'cooking',
    '3d logo',
    'glitter',
    'counter',
    'karaoke',
    'chinese',
    'footsie',
    'ganesha',
    '3d text',
    'callout',
    'bubbles',
    'airport',
    '3d city',
    'navidad',
    'opening',
    'bathing',
    'origami',
    'cartoon',
    'curtain',
    'pop art',
    'romance',
    'hacking',
    'western',
    'macbook',
    'sparkle',
    'hip hop',
    'kitchen',
    'vintage',
    'jungle',
    'sexual',
    'bumper',
    'poking',
    'ending',
    '120fps',
    'church',
    'evento',
    'doodle',
    'onlain',
    'makeup',
    'laptop',
    'racing',
    'adulat',
    'sweety',
    'bullet',
    'preset',
    'rocket',
    'matrix',
    'privat',
    'gatsby',
    'bottle',
    'boxing',
    'masala',
    'puzzle',
    'police',
    'prone',
    'peron',
    'shear',
    'bokeo',
    'lesbo',
    'brest',
    'drone',
    'fussy',
    'india',
    'robot',
    'funny',
    'boken',
    'money',
    'japan',
    'manga',
    'funky',
    'heart',
    'arrow',
    'crime',
    'mogrt',
    'vodeo',
    'eagle',
    'cloth',
    'morph',
    'crot',
    'reap',
    'pone',
    'beaf',
    'bolu',
    'peon',
    'holi',
    'toon',
    'lomo',
    'boke',
    'pore',
    'boor',
    'fron',
    'pion',
    'xmas',
    'saxo',
    'sace',
    'puck',
    'reaf',
    'ripe',
    'sacs',
    'prun',
    'pont',
    'reps',
    'neon',
    'born',
    'fcpx',
    'meme',
    'love',
    'rapa',
    'army',
    'skis',
    '8bit',
    'nide',
    'kids',
    'bubs',
    'bbw',
    'beg',
    'bur',
    'car',
    'png',
    'sew',
    'hud',
    'sss',
    'vfx',
    'scy',
    'pom',
    'wap',
    'bee',
    'mma',
    'ww'
  ]
}

const processedParamsForSite: { [site: string]: INoIndexParams[] } = {}

const noIndexAllowList = (
  { site, routes, params }: INoIndexAllowList,
  tagsBySite: AllowedTagsBySite = allAllowedTagsBySite
) => {
  if (processedParamsForSite[site] === undefined) {
    const allowedTagsBySite = tagsBySite[site] || []

    processedParamsForSite[site] = allowedTagsBySite.map(tag => ({
      name: 'tags',
      value: tag
    }))
  }

  return {
    routes: routes.concat([]),
    params: processedParamsForSite[site].concat(params)
  }
}

export default noIndexAllowList
